import {EcommerceItem, toGa4Items, toQuoteItems, toUaProducts} from './checkout-ecommerce-items';

export {toQuoteItems};
export type {EcommerceItem};

function pushEvent(payload: Record<string, any>): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ecommerce: null});
  window.dataLayer.push(payload);
}

export function trackViewCart(items: Array<EcommerceItem>, cartValue: number): void {
  pushEvent({
    event: 'view_cart',
    ecommerce: {
      currency: 'EUR',
      value: Number(cartValue) || 0,
      items: toGa4Items(items),
    },
  });
}

export function trackBeginCheckout(items: Array<EcommerceItem>, cartValue: number = 0): void {
  pushEvent({
    event: 'begin_checkout',
    ecommerce: {
      currency: 'EUR',
      value: Number(cartValue) || 0,
      items: toGa4Items(items),
    },
  });
}

export function trackUaCheckout(items: Array<EcommerceItem>, step: number, option: string = ''): void {
  pushEvent({
    event: 'checkout',
    ecommerce: {
      checkout: {
        actionField: {step, option},
        products: toUaProducts(items),
      },
    },
  });
}

export function trackAddShippingInfo(
  items: Array<EcommerceItem>,
  cartValue: number,
  shippingTier: string = '',
  couponCode: string = '',
): void {
  pushEvent({
    event: 'add_shipping_info',
    ecommerce: {
      currency: 'EUR',
      value: Number(cartValue) || 0,
      coupon: couponCode || '',
      shipping_tier: shippingTier || '',
      items: toGa4Items(items),
    },
  });
  trackUaCheckout(items, 2, shippingTier || '');
}

export function trackAddPaymentInfo(
  items: Array<EcommerceItem>,
  cartValue: number,
  paymentType: string = '',
  couponCode: string = '',
): void {
  pushEvent({
    event: 'add_payment_info',
    ecommerce: {
      currency: 'EUR',
      value: Number(cartValue) || 0,
      coupon: couponCode || '',
      payment_type: paymentType || '',
      items: toGa4Items(items),
    },
  });
  trackUaCheckout(items, 5, paymentType || '');
  trackUaCheckout(items, 6, '');
}
